<div class="report-menu">
  <div class="grid report-info">
    <div class="col-12">
      <div class="title-2">REPORT PROGRESS</div>
      <div class="report-type">FORM 1M</div>
      <div class="sub-heading">
        {{ subHeading }}
      </div>
    </div>
  </div>
  <div class="pl-1 pt-2">
    <p-panelMenu [model]="itemsSignal()" [multiple]="false"></p-panelMenu>
  </div>
</div>
